export var Flicker;
(function (Flicker) {
    Flicker[Flicker["Nothing"] = 0] = "Nothing";
    Flicker[Flicker["Image"] = 1] = "Image";
    Flicker[Flicker["Label"] = 2] = "Label";
})(Flicker || (Flicker = {}));
